import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f81cdc2a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81cdc2a')) {
      api.createRecord('f81cdc2a', component.options)
    } else {
      api.reload('f81cdc2a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f81cdc2a&", function () {
      api.rerender('f81cdc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w36wPP5Uv3xG/JS/comp/ImgFallback.vue"
export default component.exports